module.exports = __webpack_public_path__ + "img/dunhua-2.31ab7cf5.jpg";